import PropTypes from "prop-types";
import React, { useCallback, useMemo } from "react";
import { Col, Row, Form } from "react-bootstrap";

import { useAddQuery } from "../../../../hooks";
import { useSetUrlParams } from "../../../../util/helpers";
import CustomDatePicker from "../../../shared/customDatePicker";
import MultiSelectCheckbox from "../../../shared/multiSelectCheckbox";
import SortAndViewToggleList from "../../../shared/sortAndViewToggleList";

const LinkedGamesFilters = ( {
  gameList = [],
  handleChange,
  showFilter,
  values,
  sortColumns = [],
  toggleClass,
  location,
  handleFilterChange,
  clearSelectedFilter,
} ) => {
  const { addQuery } = useAddQuery();

  const handleSelect = ( filterName, obj ) => {
    handleFilterChange( filterName, obj, handleChange, addQuery, location.state );
  };

  const onSelectFilterItems = useCallback(
    [ obj => handleSelect( "gameIds", obj ) ], []
  );

  const multiSelectedItems = useMemo( () => [ values.gameIds ] );

  const clearAllSelectedOptions = useCallback(
    params => clearSelectedFilter( params, addQuery, handleChange, location.state ), []
  );

  return (
    <>
      <div className='filter-tabs-wrapper align-items-end'>
        <div className="filter-boxes mr-70">
          <div className={`filter-boxes mr-0 ${ ( !showFilter ) ? "" : "remove-filter" }`}>
            <Row>
              <Col md={4}>
                <Form.Group className='custom-multiselect mb-0'>
                  <Form.Label>Game Name</Form.Label>
                  <MultiSelectCheckbox
                    multiOptionsList={gameList}
                    handleSelectChange={onSelectFilterItems[ 0 ]}
                    multiSelectedItems={multiSelectedItems[ 0 ]}
                    handleClearMultiSelect={() => clearAllSelectedOptions( "gameIds" )} />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='custom-datepicker mb-0'>
                  <Form.Label>Start Date</Form.Label>
                  <CustomDatePicker
                    value={values.startDate}
                    handleChange={( e ) => {
                      if( e ) {
                        addQuery( useSetUrlParams( "startDate", new Date( e ).toLocaleDateString( "fr-CA" ) ), location.state );
                        handleChange( "startDate", new Date( e ).toLocaleDateString( "fr-CA" ) );
                        handleChange( "initialStartDate", new Date( e ).toLocaleDateString( "fr-CA" ) );
                      }
                      else {
                        addQuery( useSetUrlParams( "startDate", "" ), location.state );
                        handleChange( "startDate", false );
                        handleChange( "initialStartDate", null );
                      }
                    } }
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='custom-datepicker mb-0'>
                  <Form.Label>End Date</Form.Label>
                  <CustomDatePicker
                    value={values.endDate}
                    handleChange={( e ) => {
                      if( e ) {
                        addQuery( useSetUrlParams( "endDate", new Date( e ).toLocaleDateString( "fr-CA" ) ), location.state );
                        handleChange( "endDate", new Date( e ).toLocaleDateString( "fr-CA" ) );
                        handleChange( "initialEndDate", new Date( e ).toLocaleDateString( "fr-CA" ) );
                      }
                      else {
                        addQuery( useSetUrlParams( "endDate", "" ), location.state );
                        handleChange( "endDate", false );
                        handleChange( "initialEndDate", null );
                      }
                    } }
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>
        <SortAndViewToggleList
          values={values}
          addQuery={addQuery}
          sortColumns={sortColumns}
          toggleClass={toggleClass}
          handleChange={handleChange}
          locationState={location.state}
        />
      </div>
    </>
  );
};

LinkedGamesFilters.propTypes = {
  gameList: PropTypes.array,
  handleChange: PropTypes.func,
  showFilter: PropTypes.bool,
  values: PropTypes.object,
  sortColumns: PropTypes.array,
  toggleClass: PropTypes.func,
  location: PropTypes.object,
  handleFilterChange: PropTypes.func,
  clearSelectedFilter: PropTypes.func,
};

export default LinkedGamesFilters;
